import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { v4 as uuidv4 } from 'uuid';

export default function PriceLevelsEditor({ levels, setLevels }) {
  const addLevel = () => {
    setLevels([...levels, { id: uuidv4(), price: '', label: '', type: 'Support' }]);
  };

  const updateLevel = (id, field, value) => {
    setLevels(levels.map(l => l.id === id ? { ...l, [field]: value } : l));
  };

  const removeLevel = (id) => {
    setLevels(levels.filter(l => l.id !== id));
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <label className="text-xs font-black uppercase tracking-[0.2em] text-app-muted">Significant Price Levels</label>
        <button 
          type="button" 
          onClick={addLevel}
          className="text-[10px] font-black uppercase tracking-widest flex items-center gap-2 text-app-accent hover:text-yellow-400 bg-app-accent/10 px-3 py-1.5 rounded-lg border border-app-accent/20"
        >
          <FiIcons.FiPlus /> Add Level
        </button>
      </div>

      {levels.length === 0 && <div className="text-sm text-app-muted italic p-4 bg-app-bg/50 rounded-lg border border-dashed border-app-border">No levels added for this security.</div>}
      
      <div className="space-y-2">
        {levels.map(level => (
          <div key={level.id} className="flex items-center gap-2 bg-app-bg p-2 rounded-lg border border-app-border">
            <input 
              type="text" 
              placeholder="Price" 
              value={level.price} 
              onChange={(e) => updateLevel(level.id, 'price', e.target.value)}
              className="w-28 font-mono text-base font-black h-10"
            />
            <input 
              type="text" 
              placeholder="Label (e.g. Daily Res)" 
              value={level.label} 
              onChange={(e) => updateLevel(level.id, 'label', e.target.value)}
              className="flex-1 text-sm h-10"
            />
            <select 
              value={level.type} 
              onChange={(e) => updateLevel(level.id, 'type', e.target.value)}
              className="w-36 text-xs h-10 font-bold uppercase tracking-wider"
            >
              <option value="Support">Support</option>
              <option value="Resistance">Resistance</option>
              <option value="Target">Target</option>
              <option value="Stop">Stop</option>
              <option value="Key Level">Key Level</option>
            </select>
            <button 
              type="button" 
              onClick={() => removeLevel(level.id)}
              className="p-2.5 text-app-muted hover:text-app-red transition-colors"
            >
              <FiIcons.FiTrash2 size={18} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}